export default "__VITE_ASSET__CTu7$xTy__"